export default class StorageKeys {
  static readonly Email = '_EM';
  static readonly CUSTOMER_ID = '_CID';
  static readonly CONTACT_ID  = '_CTID';
  static readonly SITE_ID = '_SID';
  static readonly SPEND_ID = '_SPID';
  static readonly SELECTED_ENERGY_TYPE = '_E';
  static readonly CONTACT_DETAILS = '_CD';
  static readonly PAYMENT_DETAILS = '_PD';
  static readonly PAYMENT_ID = '_PID';
  static readonly SELECTED_ADDRESS = '_SA';
  static readonly SELECTED_METER = '_M';
  static readonly SELECTED_QUOTE = '_SQ';
  static readonly SELECTED_COMPANY = '_SC';
  static readonly CONTRACT_END_DATE = '_CED';
  static readonly SWITCH_ID = '_SWI';
  static readonly SESSION_ID = '_STID';
  static readonly UTM_PARAMS = '_UTM';
}
